import React, { useState } from "react";
import { Tooltip, Box, styled, tooltipClasses, SxProps } from "@mui/material";
import useMediaQuery from "@/shared/hooks/use-media-query";
export interface ContentTooltipProps {
  children: React.ReactNode | any;
  template: React.ReactNode | any;
  placement?: "top" | "bottom";
  sx?: SxProps;
  borderRadius?: number;
  disablePortal?: boolean;
}

const MxTooltipContent = (props: ContentTooltipProps) => {
  const { children, template } = props;
  const { isMobile } = useMediaQuery();
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };
  return (
    <Tooltip
      slotProps={{
        tooltip: {
          sx: {
            [`&.${tooltipClasses.tooltip}`]: {
              background: "white",
              width: "auto",
              height: "auto",
              maxWidth: isMobile ? "100vw" : 450,
              border: "1px solid #ccc",
              borderRadius: props.borderRadius || 0.5
            }
          }
        }
      }}
      PopperProps={{
        disablePortal: props.disablePortal ?? false
      }}
      open={isMobile ? isOpen : undefined}
      title={
        <TooltipContent
          sx={{
            background: "white",
            height: "auto",
            overflow: "hidden",
            overflowY: "auto",
            p: 1,
            ...props.sx,
            // @ts-ignore
            width: isMobile ? "90vw" : props.sx?.width || 230
          }}
        >
          {template}
        </TooltipContent>
      }
      arrow
      placement={props.placement ?? "top"}
    >
      {React.cloneElement(children, {
        onClick: (e: React.MouseEvent<HTMLDivElement>) => {
          toggleOpen();
        }
      })}
    </Tooltip>
  );
};

export default MxTooltipContent;

const TooltipContent = styled(Box)(({ theme }) => ({}));
